export default __webpack_public_path__ + "static/media/residencias.2c75858b.jpeg";